import GameObject from '../../GameObject/GameObject';
import ITask from './ITask';
import {
    GetAnimationClip,
    PlayAnimation,
    StartAnimationClip,
} from '../../System/Animation/AnimationHelper';
import AnimationClip from '../../System/Animation/AnimationClip';

export default class AnimationTask implements ITask<any> {
    public animationClip: AnimationClip;
    private skip: boolean;

    constructor(
        clipName: string,
        gameObject: GameObject,
        meta?: any,
        skip?: boolean
    ) {
        this.skip = skip || false;
        this.animationClip = GetAnimationClip(clipName, gameObject, meta);
    }

    public *execute(): IterableIterator<any> {
        if (this.skip) {
            StartAnimationClip(this.animationClip);
        } else {
            yield* PlayAnimation(this.animationClip);
        }
    }
}
